import { useMemo } from "react";
import ErrorMessage from "../../atoms/forms/ErrorMessage";
import { MagnetiqPlaceHolderImage, TrashIcon } from "../../atoms/Icon";
import { ProfileUploadWithCustomOnChange } from "../../atoms/ProfileUpload";

import InputFieldWithLabel from "../../molecules/forms/InputFieldWithLabel";
import TextAreaWithLabel from "../../molecules/forms/TextAreaWithLabel";
import ProfileImageElement from "../../molecules/ProfileImageElement";
import { MAX_MAGNET_BENEFIT_LENGTH } from "../../../constants";

function MagnetBenefitCard({ register, idx, errors, watch, handleRemoveBenefit, existingMagnetImage, setValue }: any) {
  const file = watch(`benefits.${idx}.image`) && watch(`benefits.${idx}.image`)[0];

  const handleSetBenifitImage = (fileList: FileList) => {
    setValue(`benefits.${idx}.image`, fileList, {
      shouldValidate: true,
    });
  };

  const imgSrc = useMemo(() => (file ? URL.createObjectURL(file) : existingMagnetImage), [file]);

  return (
    <div className="relative h-full w-full rounded-lg border border-white">
      {idx > 0 && (
        <div className="absolute -right-3 top-0 cursor-pointer p-4" onClick={() => handleRemoveBenefit(idx)}>
          <div className="mr-2 h-8 w-7">
            <TrashIcon />
          </div>
        </div>
      )}
      <div className="flex w-full flex-col items-start px-4 pb-0 pt-5">
        <div className="flex flex-col ">
          <div className="flex flex-row">
            <ProfileImageElement
              label="Image/Icon"
              profileImage={imgSrc}
              defaultImage={<MagnetiqPlaceHolderImage />}
              alt={`Magnet benefit image ${idx}`}
            />
            <div className="ml-5 flex items-center">
              <ProfileUploadWithCustomOnChange
                setFieldValue={handleSetBenifitImage}
                id={`benefits.${idx}.image`}
                labelClasses="mt-7"
                label={file || existingMagnetImage ? "CHANGE IMAGE" : "UPLOAD IMAGE"} // remove when pencil icon used
              />
            </div>
          </div>
          <ErrorMessage errorMessage={errors.benefits?.[idx]?.image?.message} />
        </div>
        <div className="w-full max-w-md">
          <InputFieldWithLabel
            register={register}
            label="Title"
            id={`benefits.${idx}.title`}
            placeHolder="Enter Benefit Title"
            defaultValue=""
            errorMessage={errors.benefits?.[idx]?.title?.message}
          />
        </div>
        <div className="w-full max-w-md">
          <TextAreaWithLabel
            register={register}
            label="Short Description"
            maxDescriptionWordCount={MAX_MAGNET_BENEFIT_LENGTH}
            descriptionWordCount={watch(`benefits.${idx}.description`)?.length}
            id={`benefits.${idx}.description`}
            rows={5}
            placeHolder="Enter Benefit Description"
            defaultValue=""
            errorMessage={errors.benefits?.[idx]?.description?.message}
          />
        </div>
      </div>
    </div>
  );
}
export default MagnetBenefitCard;
